<script setup>
import StatusButton from "@/shared/Button";
import _ from 'lodash';
import {CheckCircleIcon} from '@heroicons/vue/solid'
import {CheckCircleIcon as CheckingIcon} from '@heroicons/vue/outline'

import {useRoute, useRouter} from "vue-router";
import {ref} from "vue";

const router = useRouter();
const route = useRoute();
const checked = ref()

function buildFilter(key, value) {
    checked.value = route.query;
    if (_.has(checked.value, key)) {
        checked.value = _.omit(checked.value, key);
    } else {
        checked.value = Object.assign({}, checked.value, {[key]: value});
    }
    progressFilter();
}

function checkingIt(status) {
    let query = route.query;
    return !_.has(query, status);
}

function progressFilter() {
    router.replace({
        query: {
            ...checked.value
        }
    })
}
</script>

<template>
    <div class="mx-auto max-w-5xl px-4">
        <div class="mb-4 lg:flex">
            <StatusButton @click.prevent="buildFilter('completed', 1)">
                <CheckingIcon v-if="checkingIt('completed')"
                              class="ltr:-ml-1 rtl:-mr-1 ltr:mr-0.5 rtl:ml-0.5 h-5 w-5 text-blue-400"
                              aria-hidden="true"/>
                <CheckCircleIcon v-else class="ltr:-ml-1 rtl:-mr-1 ltr:mr-0.5 rtl:ml-0.5 h-5 w-5 text-blue-400"
                                 aria-hidden="true"/>
                <span class="pl-1 text-sm font-medium text-blue-400">{{ $tt('my_portal_page__filter_completed') }}<span
                    class="sr-only"></span></span>
            </StatusButton>

            <StatusButton @click.prevent="buildFilter('incomplete', 1)">
                <CheckingIcon v-if="checkingIt('incomplete')"
                              class="ltr:-ml-1 rtl:-mr-1 ltr:mr-0.5 rtl:ml-0.5 h-5 w-5 text-blue-400"
                              aria-hidden="true"/>
                <CheckCircleIcon v-else class="ltr:-ml-1 rtl:-mr-1 ltr:mr-0.5 rtl:ml-0.5 h-5 w-5 text-blue-400"
                                 aria-hidden="true"/>
                <span class="pl-1 text-sm font-medium text-blue-400">{{
                        $tt('my_portal_page__filter_in_progress')
                    }}<span class="sr-only"></span></span>
            </StatusButton>

            <StatusButton @click.prevent="buildFilter('not_started', 1)">
                <CheckingIcon v-if="checkingIt('not_started')"
                              class="ltr:-ml-1 rtl:-mr-1 ltr:mr-0.5 rtl:ml-0.5 h-5 w-5 text-blue-400"
                              aria-hidden="true"/>
                <CheckCircleIcon v-else class="ltr:-ml-1 rtl:-mr-1 ltr:mr-0.5 rtl:ml-0.5 h-5 w-5 text-blue-400"
                                 aria-hidden="true"/>
                <span class="pl-1 text-sm font-medium text-blue-400">{{
                        $tt('my_portal_page__filter_not_started')
                    }}<span class="sr-only"></span></span>
            </StatusButton>
        </div>
    </div>
</template>



